import React from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';
import { selectSiteUrl } from 'core/selectors/app';
import { useGetInstoreOffers } from 'core/modules/Instore2/hooks/useGetInstoreOffers';
import { useGetInstoreOffersTitle } from 'core/modules/Instore2/hooks/useGetInstoreOffersTitle';
import InstoreOfferTile from 'core/modules/Instore2/components/InstoreOfferTile/InstoreOfferTile';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import { FEATURED_INSTORE_OFFERS_ID } from 'core/modules/Instore2/utils/constants';
import List from 'core/modules/Partials/List/List';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import InstoreEducationalTile from 'core/modules/Instore2/components/InstoreEducationalTile/InstoreEducationalTile';
import orgConfig from 'org/configs/org.config';
import {
  useTriggerInstoreTileIsViewedGaEvent,
} from 'core/modules/Instore2/hooks/useTriggerInstoreTileIsViewedGaEvent';

import config from './configs';

import './FeaturedInstoreOffers.scss';

function FeaturedInstoreOffers({ customConfig }) {
  const siteUrl = useSelector(selectSiteUrl);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const combinedConfig = merge({}, config, customConfig);
  const { earnType } = orgConfig;

  const {
    api, getViewAllLinkUrl, getViewAllLinkTitle, getStaticTitle, contentWrap, checkShouldUseCarousel, carousel,
    shouldUseDesktopTileOnMobile, shouldShowEducationalTile,
  } = combinedConfig;

  const { offers } = useGetInstoreOffers({
    namespace: FEATURED_INSTORE_OFFERS_ID,
    componentParams: api.offers.params,
  });
  const { title } = useGetInstoreOffersTitle({
    namespace: FEATURED_INSTORE_OFFERS_ID,
    componentParams: api.title.params,
    staticTitle: getStaticTitle(earnType),
  });

  const shouldUseCarousel = checkShouldUseCarousel(isMobileMQ);

  useTriggerInstoreTileIsViewedGaEvent(offers);

  if (isEmpty(offers) || isEmpty(title)) {
    return null;
  }

  const viewAllLinkUrl = getViewAllLinkUrl(siteUrl);
  const viewAllLinkTitle = getViewAllLinkTitle();

  return (
    <div className="mn_featuredInstoreOffers">
      <ContentWrap {...contentWrap}>
        <SectionTitle
          title={title}
          viewAllLinkUrl={viewAllLinkUrl}
          viewAllLinkTitle={viewAllLinkTitle}
        />
        <List
          shouldUseCarousel={shouldUseCarousel}
          options={carousel}
          hasFillers={isMobileMQ ? 0 : 4}
          fillerClassName="mn_instoreOfferTileFiller"
        >
          {offers.map((offer) => (
            <InstoreOfferTile
              key={offer.offerId}
              offer={offer}
              namespace={FEATURED_INSTORE_OFFERS_ID}
              shouldUseDesktopTileOnMobile={shouldUseDesktopTileOnMobile}
            />
          ))}
          <InstoreEducationalTile
            offers={offers}
            shouldShowTile={shouldShowEducationalTile}
            shouldUseDesktopTileOnMobile={shouldUseDesktopTileOnMobile}
          />
        </List>
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><FeaturedInstoreOffers {...props} /></ComponentErrorBoundary>;
